import { useEffect, useRef, useState } from 'react';
import { useLocalStorageState } from '../local-storage.hooks';
import {
  EmailTemplateFilter,
  EmailTemplateLocalStorage,
} from '@/entities/email-template';
import debounce from 'lodash/debounce';

interface EmailTemplateFilterProps {
  setCurrentPage: (page: number) => void;
}

export const useEmailTemplateFilter = ({
  setCurrentPage,
}: EmailTemplateFilterProps) => {
  const [debouncedFilter, setDebouncedFilter] = useState<EmailTemplateFilter>({
    key: '',
  });
  const filtersEmptyRef = useRef<boolean>(true);

  /**
   * === Filter section ===
   */
  const [key, setKey] = useLocalStorageState({
    key: EmailTemplateLocalStorage.KEY,
    removeOnClose: true,
  });

  const [type, setType] = useLocalStorageState({
    key: EmailTemplateLocalStorage.TYPE,
    removeOnClose: true,
  });

  const [status, setStatus] = useLocalStorageState({
    key: EmailTemplateLocalStorage.STATUS,
    removeOnClose: true,
  });

  useEffect(() => {
    setDebouncedFilter((prev) => ({
      ...prev,
      key: key || '',
      type,
      status,
    }));

    filtersEmptyRef.current = !key && !type && !status;
  }, [key, type, status]);

  const searchByKey = (value: string) => {
    setKey(value);
    debounce((value: string) => {
      setDebouncedFilter((prev) => ({ ...prev, key: value }));
    }, 1000);
  };

  const searchByType = (value: string) => {
    setType(value);
    setDebouncedFilter((prev) => ({ ...prev, type: value }));
  };

  const searchByStatus = (value: string) => {
    setStatus(value);
    setDebouncedFilter((prev) => ({ ...prev, status: value }));
  };

  const clearFilters = () => {
    setKey('');
    setType('');
    setStatus('');
    setCurrentPage(1);
  };
  /**
   * === END OF Filter section ===
   */

  return {
    debouncedFilter,
    setDebouncedFilter,
    filtersEmpty: filtersEmptyRef.current,
    clearFilters,
    key,
    type,
    status,
    searchByKey,
    searchByType,
    searchByStatus,
  };
};
